<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новый промокод</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" :loading="loading" :disabled="loading" @click="sendForm" class="v-btn--save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Заголовок</v-subheader>
                    <v-textarea
                        ref="promo_description"
                        v-model="promo.description"
                        single-line
                        text
                        solo
                        counter="191"/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Количество использований</v-subheader>
                            <v-text-field
                                ref="promo_all_count"
                                v-model="promo.all_count"
                                mask="######"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Количество бонуса</v-subheader>
                            <v-text-field
                                ref="promo_bonus_count"
                                v-model="promo.bonus_count"
                                v-validate="'required'"
                                data-vv-name="bonus_count"
                                :error-messages="errors.collect('bonus_count')"
                                mask="######"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5 style="position: relative;">
                            <v-subheader class="pa-0">Название промокода</v-subheader>
                            <v-text-field
                                id="promo_name"
                                ref="promo_name"
                                v-model="promo.name"
                                v-validate="'required|max:50'"
                                data-vv-name="name"
                                :error-messages="errors.collect('name')"
                                single-line
                                text
                                solo
                                required/>
                            <v-tooltip bottom style="position: absolute; bottom: 26px; right: 0;">
                                <template slot="activator">
                                    <v-btn text icon @click.prevent="copyToClipboard">
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Скопировать в буфер</span>
                            </v-tooltip>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0"></v-subheader>
                            <div class="action-btn w-100">
                                <v-btn color="info" @click="generateName" class="v-btn--generate">Сгенерировать</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Promo from '../../../../api/promo'

    export default {
        name: 'AddPromo',
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            loader: false,
            promo: {
                name: '',
                description: '',
                all_count: 1,
                bonus_count: 1000,
                status: 1
            },
            dictionary: {
                custom: {
                    name: {
                        required: 'Название не выбрано'
                    },
                    bonus_count: {
                        required: 'Нужно указать количетво бонусов'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            generateName () {
                Promo
                    .generateName()
                    .then(response => this.promo.name = response.data)
                    .catch(error => new Error(error))
            },
            copyToClipboard () {
                const el = document.getElementById('promo_name')

                if (!el.value) return

                el.select()
                document.execCommand('copy')
                this.$store.commit('showSnackbar', {
                    text: 'Промокод скопирован в буфер обмена',
                    color: 'info'
                })
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        if (this.promo.all_count === 0 || this.promo.all_count === '') {
                            this.$store.commit('showSnackbar', { text: 'Количество использований должен быт больше нулья' })

                            return
                        }

                        if (this.promo.bonus_count === 0 || this.promo.bonus_count === '') {
                            this.$store.commit('showSnackbar', { text: 'Количество начисляемых баллов не может быть меньше единицы' })

                            return
                        }

                        this.loading = true

                        Promo
                            .create(this.promo)
                            .then(response => {
                                this.$store.commit('addPromo', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Промокод добавлен',
                                    color: 'success'
                                })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>
